import { useTranslation } from 'react-i18next';
import { match } from 'ts-pattern';

import { Alert, Button } from '~/components';

import { useRegistrationContext } from '../Registration.context';
import { closeButtonStyle } from './RegistrationReferralCodeInformation.css';

export const RegistrationReferralCodeInformation = () => {
  const { referralCodeInformation, setHadReferralCode, setReferralCodeInformation } = useRegistrationContext();

  const { t } = useTranslation(['auth', 'common']);

  if (!referralCodeInformation) return null;

  return (
    <Alert announce={false} icon="Redeem" status="success" title={t('auth:registrationPage.common.referralCode.applied')}>
      {match(referralCodeInformation)
        .with({ invitorType: 'admin' }, () =>
          t('auth:registrationPage.common.referralCode.types.fromAdmin.generic', {
            referralCode: referralCodeInformation.code,
          }),
        )
        .with({ invitorType: 'user' }, () =>
          t('auth:registrationPage.common.referralCode.types.fromUser', {
            referralCode: referralCodeInformation.code,
            name: referralCodeInformation.invitorName,
          }),
        )
        .with({ invitorType: 'accountant' }, () =>
          t('auth:registrationPage.common.referralCode.types.fromAccountant', {
            referralCode: referralCodeInformation.code,
            name: referralCodeInformation.invitorName,
          }),
        )
        .exhaustive()}

      <Button
        aria-label={t('common:actions.delete')}
        className={closeButtonStyle}
        icon="CloseSmall"
        onClick={() => {
          setReferralCodeInformation(null);
          setHadReferralCode(true);
        }}
      />
    </Alert>
  );
};
